/* eslint-disable */
import AuthService from "@/services/AuthService";
import TeamService from "@/services/TeamService";
import moment from "moment";
import { debounce } from "lodash";
import { defineStore } from "pinia";
import { toast } from "vue3-toastify";

export const useTeamStore = defineStore("TeamStore", {

  state: () => ({

    formData: {
      name: ""
    },

    teams: [],
    currentTeam: {},

    showCreateTeamModal: false,
    showDeleteTeamModal: false,
    showEditTeamNameModal: false,

    showDeleteEmployeeModal: false,

    currentUser: {},

    currentEmployee: {},

    team: {},
    employees: [],
    showCopyEmployeeToAontherTeamModal: false,
    
    showTableOptions: false,
    selectedEmployees: [],

    copyUsersToTeamFormData: {
      team_id: null,
      employees: null
    },

    isLoading: false,

    showGroupDeleteModal: false,
    teamCount: null,

    showDeleteSupervisorTeamModal: false,

    team_size_limit: null,
    used_seats_amt: null,
    seats_available_amt: null,

    currentAddNewUserStep: "add_user_details",
    newInspectionUsersArray: [],
    allGroups: [],
    back_log_date: null,
    showBackLogDateError: false,

    inspectionAppUserRoles: [
      {
        id: 1,
        name: "Employee",
        role_type: "employee",
      },
      // {
      //   id: 2,
      //   name: "Inspector",
      //   role_type: "inspector",
      // },
    ],

    currentNewUser: {},

    showEditNewUserToGroupModal: false,
    isAddingNewUsers: false,
    showEditNewUserSiteModal: false,

    showBacklogDateExplainationModal: false,

    showActivateDeactiveModal: false,
    activateModalType: null,

    showEditUserDetailsModal: false,

    updateUserFormData: {
      first_name: null,
      last_name: null
    },

    newGroupTalkUsersArray: [],

    showEditNewGroupTalkUserToGroupModal: false,

    newUsersAddedToGroupTalkSuccess: false,

    showButtonNavModal: false,

    showTeamDeletionLogsModal: false,

    teamDeletionLogs: [],

    isloadingTeamDeletionLogs: false,

    isTeamDeletionPermissionChecked: 0,

    



  }),

  getters: {

    buildInviteLink: (state) => (team_id) => {
      // var url = "http://localhost:3000/employee/register?" + 'j6wsywtmcYdssni=' + state.currentUser.id + '&' + 'u9bdnfidsnwwn=' + team_id;

      // var url = "http://localhost:3000/employee/register?" + 'j6wsywtmcYdssni=' + state.currentUser.id + '&' + 'u9bdnfidsnwwn=' + team_id + '&' + 'app=' + 'talks';

      var url = "http://mysafelyio.app/employee/register?" + 'j6wsywtmcYdssni=' + state.currentUser.id + '&' + 'u9bdnfidsnwwn=' + team_id + '&' + 'app=' + 'talks';

      return url;
    }

  },


  actions: {


    fetchAllTeams() {

      TeamService.getAllTeams().then((response) => {

        this.teams = response.data.teams;


        // // eslint-disable-next-line no-console
        // console.log(response.data);
        
      });
    },

    fetchUser() {

      AuthService.getUser()
        .then((response) => {

          this.currentUser = response.data;

          // // eslint-disable-next-line no-console
          // console.log(response.data)

        }).catch((err) => {

          // eslint-disable-next-line no-console
          console.log(err)

        });

    },

    storeNewTeam() {

      TeamService.saveNewTeam(this.formData)
        .then(() => {

          this.fetchAllTeams()

          this.closeCreateTeamModal()

          this.formData.name = ''

          // console.log(response.data);

        }).catch((error) => {

          // eslint-disable-next-line no-console
          console.log(error);

        });

    },

    updateThisTeam() {

      // console.log(this.formData)

      TeamService.updateTeam(this.currentTeam.random_string, this.formData)
        .then((response) => {

          this.fetchAllTeams();

          this.closeEditTeamModal()

          // // eslint-disable-next-line no-console
          // console.log(response.data);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });

    },

    deleteTeam() {

      if(!this.isTeamDeletionPermissionChecked){
        alert("Please select the checkbox to confirm this team's deletion")
        return;
      }      


      TeamService.deleteTeamService(this.currentTeam.random_string)
        .then((response) => {

          this.fetchAllTeams();

          this.closeDeleteTeamModal()

          // // eslint-disable-next-line no-console
          // console.log(response.data);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });


    },


    setCurrentTeam(team) {
      this.currentTeam = team;
      this.formData.name = this.currentTeam.name;
      // console.log(team)
    },



    openCreateTeamModal() {
      this.showCreateTeamModal = true
    },

    closeCreateTeamModal() {
      this.showCreateTeamModal = false
    },

    openDeleteTeamModal() {
      this.isTeamDeletionPermissionChecked = 0
      this.showDeleteTeamModal = true
    },

    closeDeleteTeamModal() {
      this.showDeleteTeamModal = false
    },

    openEditTeamModal() {
      this.showEditTeamNameModal = true
    },

    closeEditTeamModal() {
      this.showEditTeamNameModal = false
      this.formData.name = ''
    },

    openShowDeleteEmployeeModal() {
      this.showDeleteEmployeeModal = true
    },

    closeShowDeleteEmployeeModal() {
      this.showDeleteEmployeeModal = false
    },


    copyLink(index) { 

      const linkInputField = document.getElementById('inviteLinkInputField' + index);

      linkInputField.select();

      document.execCommand('copy');

      alert('Link copied!');

    },


    setCurrentEmployee(employee) {
      this.currentEmployee = employee
    },


    softDeleteThisEmployee() {  

      const formData = {
        user_id: this.currentEmployee.id,
        team_id: this.team.id
      }


      TeamService.deleteAEmployeeFromTeam(formData)
        .then((response) => {


          let employeeIndexToDelete = this.employees.findIndex(
            (emp) => emp.id === this.currentEmployee.id
          );


          if (employeeIndexToDelete !== -1) {
            this.employees.splice(employeeIndexToDelete, 1);
          }

 

          this.closeShowDeleteEmployeeModal()

          // console.log(response.data)

         

        }).catch((err) => {

          console.log(err)

        });

    },


    softDeleteThisEmployeeCompletely(){

      const formData = {
        user_id: this.currentEmployee.id
      }

      TeamService.deleteEmployeeCompletelyAcrossAllApps(formData)
        .then((response) => {

          this.closeShowDeleteEmployeeModal()
          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });

      console.log('completely')


    },

    goBackToViewAllTeams() {
      this.router.push({
        name: "ViewAllTeams"
      });
    },


    fetchTeam(random_string) {

      this.selectedEmployees = []

      TeamService.getATeam(random_string)
        .then((response) => {

          this.team = response.data.team
          this.teamCount = response.data.count

          //add is_selected to each object
          let employeeArray = response.data.employees

          employeeArray.forEach((emp) => {
            // Add is_selected property set to false for each employee object
            emp.is_selected = false;
          });

          this.employees = employeeArray
          

          

          // // eslint-disable-next-line no-console
          // console.log(response.data)

        }).catch((err) => {

          // eslint-disable-next-line no-console
          console.log(err)

        });
    },

    formatDate(date){

      return moment(date).format("MMMM Do YYYY"); 

    },


    openCopyEmployeeToAontherTeamModal(){
      this.showCopyEmployeeToAontherTeamModal = true 
    },

    closeCopyEmployeeToAontherTeamModal(){
      this.showCopyEmployeeToAontherTeamModal = false
    },

    openTableOptions(){
      this.showTableOptions = true
    },

    closeTableOptions(){
      this.showTableOptions = false
    },


    toggleSelection(employee){
      employee.is_selected = !employee.is_selected;
    },

    addrOrRemoveUser(employee){


      //add to array else remove from array
      if(employee.is_selected){

        this.selectedEmployees.push(employee)

      }else{


        let userIndexToRemove = this.selectedEmployees.findIndex(
          (emp) => emp.id === employee.id
        );


        if (userIndexToRemove !== -1) {
          this.selectedEmployees.splice(userIndexToRemove, 1);
        }

      }

      
      
    },


    opemShowGroupDeleteModal(){
      this.showGroupDeleteModal = true
    },

    closeShowGroupDeleteModal(){
      this.showGroupDeleteModal = false
    },

    removeEmployeeFromSelectedArray(employee){

      let userIndexToRemove = this.selectedEmployees.findIndex(
        (emp) => emp.id === employee.id
      );


      if (userIndexToRemove !== -1) {
        this.selectedEmployees.splice(userIndexToRemove, 1);
      }

      employee.is_selected = false

    },

    copyUsersToTeam(){

      this.isLoading = true 

      this.copyUsersToTeamFormData.employees = this.selectedEmployees

      TeamService.copyEmployeesToThisTeam(this.copyUsersToTeamFormData)
          .then((response) => {

            this.isLoading = false
            this.closeCopyEmployeeToAontherTeamModal()

            this.selectedEmployees = []
            this.fetchTeam(this.team.random_string)

            // console.log(response.data)


            
          }).catch((err) => {

            console.log(err)
            
          });
      

    },

    deleteGroupOfUsers(){    


      if(this.selectedEmployees.length > 0){

        const formData = {
          selectedEmployees: this.selectedEmployees,
          team_id: this.team.id
        }

        TeamService.deleteAListOfEmployees(formData)
          .then((response) => {


            this.selectedEmployees.forEach((empToDelete) => {

              let employeeIndexToDelete = this.employees.findIndex(
                (emp) => emp.id === empToDelete.id
              );
    
    
              if (employeeIndexToDelete !== -1) {
                this.employees.splice(employeeIndexToDelete, 1);
              }
              
            });

            this.closeShowGroupDeleteModal()
            this.selectedEmployees = []
            
            // console.log(response.data)
            
          }).catch((err) => {

            console.log(err)
            
          });

       

  

      }else{
        alert("No users in selection list")

        this.closeShowGroupDeleteModal()
      }

      
    },

    getAllTeamsExceptCurrentTeam() {
      return this.teams.filter(team => team.id !== this.team.id);
    },

    

    openDeleteSupervisorTeamModal(team){
      this.setCurrentTeam(team)
      this.isTeamDeletionPermissionChecked = 0
      this.showDeleteSupervisorTeamModal = true
    },

    closeDeleteSupervisorTeamModal(){
      this.showDeleteSupervisorTeamModal = false
    },


    deleteThisSupervisorTeam() {


      if(!this.isTeamDeletionPermissionChecked){
        alert("Please select the checkbox to confirm this team's deletion")
        return;
      }      


      // console.log("go on...")


        const formData = {
          random_string: this.currentTeam.random_string
        }
  
  
        TeamService.deleteSupervisorTeam(formData)
          .then((response) => {
  
            this.fetchAllTeams();
            this.closeDeleteSupervisorTeamModal()
  
            // eslint-disable-next-line no-console
            console.log(response.data);
  
          })
          .catch((error) => {
  
            // eslint-disable-next-line no-console
            console.log(error);
  
          });



    

    },


    goToAddNewUserView() {
      this.router.push({
        name: "AddNewUsers"
      });
    },


    fetchataForAddNewUsersView(){

      TeamService.getDataForAddNewUsersView()
        .then((response) => {

          this.allGroups = response.data.teams;
          this.team_size_limit = response.data.team_size_limit;
          this.used_seats_amt = response.data.used_seats_amt;
          this.seats_available_amt = response.data.seats_available_amt;

          this.populateNewInspectionUsersArray();

          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });



    },


    populateNewInspectionUsersArray() {
      this.currentAddNewUserStep = "add_user_details";
      this.newInspectionUsersArray = [];
      this.addNewUserBox();
    },


    addNewUserBox() {

      if (this.newInspectionUsersArray.length !== this.seats_available_amt) {

        this.newInspectionUsersArray.push({
          email: "",
          is_email_valid: "no",
          error_message: "",
          first_name: "",
          last_name: "",
          password: "password123",
          role_type: "",
          teams: [],
  
          show_error: 0,
        });
      } else {
        alert(
          "Seat limit reached! Please contact account manager for upgrade."
        );
      }

    },

    checkIfEmailIsVaildAndDoNotExistsInDB: debounce(function (newUser) {

      if(newUser.email === null || newUser.email === ''){
        // console.log('email field empty!')
        return
      }

      // console.log("trigger the check email:", newUser.email);

      const formData = {
        email: newUser.email,
      };

      TeamService.checkIfEmailIsVaildAndDoNotExistsInDBForToolboxTalk(formData)
        .then((response) => {
          let message = response.data.message;
          let info = response.data.info;

          if (message === "email_is_valid") {

            newUser.is_email_valid = "yes";
            newUser.show_error = 0;
            newUser.error_message = "";

            // console.log("EMAIL IS VALID");
          }

          if (message === "not_valid") {

            newUser.error_message = info;
            newUser.is_email_valid = "no";
            newUser.show_error = 1;

            // console.log("EMAIL IS NOT VALID");
          }

          // console.log(response.data)
        })
        .catch((err) => {
          console.log(err);
        });
    }, 3000),


    deleteANewUserFromArray(index) {
      this.newInspectionUsersArray.splice(index, 1);
    },


    goToSelectTeamAndSite() {
      if ( this.checkBacklogDateSelected() &&
        this.checkUserDetailsInputsAreVaild() &&
        this.checkEmailValidationResults()
      ) {
        this.currentAddNewUserStep = "select_team_and_site";

        this.populateTeamsForEachUser();
      }
    },

    checkBacklogDateSelected() {

      this.resetErrors();

      let isValid = true; // Assume valid by default

      if(this.back_log_date === null || this.back_log_date === ''){

        isValid = false
        this.showBackLogDateError = true
        // console.log('Please select a backlog date!')

      }


      return isValid;
    },
    
    checkUserDetailsInputsAreVaild() {
      this.resetErrors();

      let isValid = true; // Assume valid by default

      this.newInspectionUsersArray.forEach((user) => {
        if (
          !user.email?.trim() ||
          !user.email.includes("@") ||
          !user.first_name?.trim() ||
          !user.last_name?.trim() ||
          !user.password?.trim()
        ) {
          user.show_error = 1;
          isValid = false; // Set to false if any field is invalid
        }
      });

      return isValid;
    },

    checkEmailValidationResults() {
      let isValid = true; // Assume valid by default

      this.newInspectionUsersArray.forEach((user) => {
        if (user.is_email_valid === "no") {
          user.show_error = 1;
          isValid = false; // Set to false if any field is invalid
        }
      });

      return isValid;
    },

    resetErrors() {
      this.newInspectionUsersArray.forEach((user) => {
        user.show_error = 0;
      });

      this.showBackLogDateError = false
    },

    populateTeamsForEachUser() {
      this.newInspectionUsersArray.forEach((newUser) => {
        // Use a Set to track existing team IDs to prevent duplicates
        const existingTeamIds = new Set(newUser.teams.map((team) => team.id));

        this.allGroups.forEach((group) => {
          // Only add if the team ID is not already in the existing teams
          if (!existingTeamIds.has(group.id)) {
            newUser.teams.push({
              id: group.id,
              name: group.name,
              is_checked: 0,
            });
            // Add the new ID to the set to prevent future duplicates
            existingTeamIds.add(group.id);
          }
        });
      });
    },

    setCurrentNewUser(newUser) {
      this.currentNewUser = newUser;

      this.openEditNewUserToGroupModal();
    },

    openEditNewUserToGroupModal() {
      this.showEditNewUserToGroupModal = true;
    },

    closeEditNewUserToGroupModal() {
      this.showEditNewUserToGroupModal = false;
    },

   
    goToAddNewUserDetails() {
      this.currentAddNewUserStep = "add_user_details";
    },
    

    finallyAddNewUsersComplete() {

      for (const user of this.newInspectionUsersArray) {

        if (user.role_type === "") {
          alert("Please make sure a role is selected for each user!");
          return false;
        }

        const hasSelectedTeam = user.teams.some(
          (team) => team.is_checked === 1
        );

        if (!hasSelectedTeam) {
          alert("Please make sure a team is selected for each user!");
          return false;
        }

    
        
      }

      this.isAddingNewUsers = true;

      const formData = {
        backlog_start_date: this.back_log_date,
        newUsers: this.newInspectionUsersArray,
      };


      // console.log(formData)

      TeamService.toolboxTalkAppAdminFinallyAddNewUsersService(formData)
        .then((response) => {

          //deleay a bit
          setTimeout(() => {
            this.goToAddNewUsersResultsComplete();
            this.isAddingNewUsers = false;
            // console.log(response.data);
          }, 5000);


        })
        .catch((err) => {

          // this.isAddingNewUsers = false;

          console.log(err);
        });
    },

    updateCurrentGroupList(group) {
      //if the status id true/1 switch to false
      if (group.is_checked) {
        group.is_checked = 0;
      } else {
        group.is_checked = 1;
      }
    },

    closeEditNewUserSiteModal() {
      this.showEditNewUserSiteModal = false;
    },

    

    openBacklogDateExplainationModal(){
      this.showBacklogDateExplainationModal = true
    },

    closeBacklogDateExplainationModal(){
      this.showBacklogDateExplainationModal = false
    },

    goToAddNewUsersResultsComplete() {
      this.currentAddNewUserStep = "added_users_results";
    },


    openActivateDeactiveModal(employee, status){

      this.setCurrentEmployee(employee)
      this.activateModalType = status
      this.showActivateDeactiveModal = true

    },

    closeActivateDeactiveModal(){
      this.showActivateDeactiveModal = false
    },

    toggleActivateReactivate(){


      if(this.currentEmployee.is_active === 1){

        //set to 0
        this.currentEmployee.is_active = 0
        this.updateStatus()

      }else{

        this.currentEmployee.is_active = 1
        this.updateStatus()
      }

      
    },

    

    updateStatus(){

      const formData = {
        employee: this.currentEmployee
      }

      // console.log(this.currentEmployee.is_active) 

      TeamService.activateReativateUserService(formData)
        .then((response) => {

          // this.fetchAllEmployees()
          this.closeActivateDeactiveModal()

          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });

      // console.log(formData)

    },


    


    openEditUserDetailsModal(employee){
      this.setCurrentEmployee(employee)
      this.showEditUserDetailsModal = true
    },


    closeEditUserDetailsModal(){
      this.showEditUserDetailsModal = false
    },



    updateUserDetails(){


      const formData = {
        current_user: this.currentEmployee
      }


      TeamService.updateUserDetailsService(formData)
        .then((response) => {


          this.currentEmployee.name = this.currentEmployee.fname + ' ' + this.currentEmployee.lname

          this.closeEditUserDetailsModal()
          
          toast("User updated!", {
            position: "bottom-right",
            autoClose: 1000,
          });

          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });


      // console.log(formData)
  

    },


    goToAddNewGroupTalkUserView() {
      this.router.push({
        name: "AddNewGroupTalkUsers"
      });
    },


    populateNewGroupTalkUsersArray() {
      this.newGroupTalkUsersArray = [];
      this.addNewGroupTalkUserBox();
    },

    addNewGroupTalkUserBox() {

        this.newGroupTalkUsersArray.push({
          error_message: "",
          first_name: "dddd",
          last_name: "wwww",
          role_type: "",
          teams: [],
          show_error: 0,
        });
     

    },

    populateTeamsForEachGroupTalkUser() {

      this.newGroupTalkUsersArray.forEach((newUser) => {
        // Use a Set to track existing team IDs to prevent duplicates
        const existingTeamIds = new Set(newUser.teams.map((team) => team.id));

        this.allGroups.forEach((group) => {
          // Only add if the team ID is not already in the existing teams
          if (!existingTeamIds.has(group.id)) {
            newUser.teams.push({
              id: group.id,
              name: group.name,
              is_checked: 0,
            });
            // Add the new ID to the set to prevent future duplicates
            existingTeamIds.add(group.id);
          }
        });
      });
    },

    fetchDataForAddNewGroupTalkUsersView(){

      this.newUsersAddedToGroupTalkSuccess = false;

      TeamService.getDataForAddNewUsersView()
        .then((response) => {

          this.allGroups = response.data.teams;

          this.populateNewGroupTalkUsersArray();
          this.populateTeamsForEachGroupTalkUser()

          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });



    },


    addNewGroupTalkUserBox() {


        this.newGroupTalkUsersArray.push({
          error_message: "",
          first_name: "",
          last_name: "",
          role_type: "",
          teams: [],
          show_error: 0,
        });
 

      this.populateTeamsForEachGroupTalkUser()


    },

    deleteANewGroupTalkUserFromArray(index) {
      this.newGroupTalkUsersArray.splice(index, 1);
    },


    openEditNewGroupTalkUserToGroupModal(){
      this.showEditNewGroupTalkUserToGroupModal = true
    },

    closeEditNewGroupTalkUserToGroupModal(){
      this.showEditNewGroupTalkUserToGroupModal = false
    },

    setCurrentNewGroupTalkUser(newUser){
      this.currentNewUser = newUser
      this.openEditNewGroupTalkUserToGroupModal()
    },

    formValidationCheck(){

      for (const user of this.newGroupTalkUsersArray) {

        if (user.first_name === "") {
          alert("Please make sure the first name is added for each user!");
          user.error_message = "Please make sure the first name is added for each user!";
          return false;
        }

        if (user.last_name === "") {
          alert("Please make sure the last name is added for each user!");
          user.error_message = "Please make sure the last name is added for each user!";
          return false;
        }


        if (user.role_type === "") {
          alert("Please make sure a role is selected for each user!");
          user.error_message = "Please make sure a role is selected for each user";
          return false;
        }

        const hasSelectedTeam = user.teams.some(
          (team) => team.is_checked === 1
        );

        if (!hasSelectedTeam) {
          alert("Please make sure a team is selected for each user!");
          user.error_message = "Please make sure a team is selected!";
          user.show_error = 1;
          return false;
        }

    
        
      }

    },

    checkNewGroupTalkUserDetailsInputsAreVaild() {
      
      this.resetGroupTalkAddingNewUsersErrors();

      let isValid = true; // Assume valid by default

      this.newGroupTalkUsersArray.forEach((user) => {
        if (
          !user.first_name?.trim() ||
          !user.last_name?.trim() ||
          !user.role_type?.trim() 
        ) {
          user.show_error = 1;
          isValid = false; // Set to false if any field is invalid
        }
      });

      return isValid;
    },


    resetGroupTalkAddingNewUsersErrors() {
      this.newGroupTalkUsersArray.forEach((user) => {
        user.show_error = 0;
      });

    },


    validateNewGroupTalkUsers() {

      this.resetGroupTalkAddingNewUsersErrors();
    
      let isValid = true;
    
      this.newGroupTalkUsersArray.forEach((user) => {
    
        user.error_message = "";
    
        // First Name
        if (!user.first_name || !user.first_name.trim()) {
          user.show_error = 1;
          user.error_message = "First name is required";
          isValid = false;
          return;
        }
    
        // Last Name
        if (!user.last_name || !user.last_name.trim()) {
          user.show_error = 1;
          user.error_message = "Last name is required";
          isValid = false;
          return;
        }
    
        // Role
        if (!user.role_type || !user.role_type.trim()) {
          user.show_error = 1;
          user.error_message = "Please select a role";
          isValid = false;
          return;
        }
    
        // Team check
        const hasSelectedTeam = user.teams?.some(team => team.is_checked === 1);
    
        if (!hasSelectedTeam) {
          user.show_error = 1;
          user.error_message = "Please select at least one team";
          isValid = false;
          return;
        }
    
      });
    
      return isValid;
    },
    

    finallyAddNewGroupTalkUsers(){

      

      if (!this.validateNewGroupTalkUsers()) {
        return;
      }
    
      this.isAddingNewUsers = true;

      const formData = {
        newUsers: this.newGroupTalkUsersArray,
      };


      TeamService.toolboxTalkGroupTalkAdminFinallyAddNewUsersService(formData)
        .then((response) => {

           //deleay a bit
           setTimeout(() => {
            this.newUsersAddedToGroupTalkSuccess = true;

            this.isAddingNewUsers = false;
            // console.log('SUCCESS', response.data)
       
          }, 5000);

         
          
        }).catch((err) => {

          this.isAddingNewUsers = false;

          console.log(err)
          
        });

    },


    getAManagerAppAccessInfoForGroupTalk() {


      this.showButtonNavModal = false //reset for 'both' button that trggers modal

      TeamService.getAManagerAppsAccessStatusForGroupTalkService()  
        .then((response) => { 


          this.toolbox_talk_app = response.data.toolbox_talk_app

          // console.log("toolbox_talk_app", this.toolbox_talk_app)





        }).catch((err) => {

          console.log(err)

        });
    }, 


    openAddingNewUsersButtonNavModal(){
      this.showButtonNavModal = true
    },

    closeAddingNewUsersButtonNavModal(){
      this.showButtonNavModal = false
    },

    openTeamDeletionLogsModal(){
      this.fetchAllTeamDeletionLogs()
      this.showTeamDeletionLogsModal = true
    },

    closeTeamDeletionLogsModal(){
      this.showTeamDeletionLogsModal = false
    },

    fetchAllTeamDeletionLogs(){

      this.isloadingTeamDeletionLogs = true
      this.teamDeletionLogs = [] //reset

      TeamService.getTeamDeletionLogsService()
        .then((response) => {

          this.teamDeletionLogs = response.data.records
          this.isloadingTeamDeletionLogs = false

          // console.log(response.data)

          
          
        }).catch((err) => {

          this.isloadingTeamDeletionLogs = false

          console.log(err)
          
        });


    },

    updateTeamDeletionSelection() {


        //if the status id true/1 switch to false
        if (this.isTeamDeletionPermissionChecked) {
          this.isTeamDeletionPermissionChecked = 0;
        } else {
          this.isTeamDeletionPermissionChecked = 1;
        }



    },


    










  },
});
